import { Zap } from "lucide-react";

const items = [
  "24 horas no local",
  "Diagnóstico eletrônico",
  "Motor de arranque",
  "Alternador",
  "Bomba de combustível",
  "Elétrica em geral",
  "Balneário Camboriú",
  "Itajaí · Camboriú · Itapema",
];

export default function Marquee() {
  const row = [...items, ...items];
  return (
    <div data-testid="editorial-marquee" className="relative border-y border-white/5 bg-[#0c0e12] py-5 overflow-hidden">
      <div className="marquee-track flex whitespace-nowrap w-max">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-display font-bold uppercase tracking-[0.15em] text-sm sm:text-base text-slate-500 px-6">
                  {item}
                </span>
                <Zap className="w-4 h-4 text-[#e8112d]" fill="currentColor" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
